import { todayHero } from "@/mocks/evidence";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20crimson%20and%20ink%20black%20texture%20with%20subtle%20newspaper%20print%20overlay%2C%20vintage%20tape%20and%20paper%20debris%2C%20editorial%20collage%20shadow%2C%20moody%20journalistic%20archive%20background%2C%20minimal%20magazine%20cover%20mood%2C%20deep%20contrast%2C%20no%20text&width=1800&height=760&seq=ev-hero-bg&orientation=landscape"
        alt="国产黑料证据档案封面底图"
        className="absolute inset-0 h-full w-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/70 to-foreground-950/40" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-20 md:px-6 md:pb-24 md:pt-28">
        <div className="flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-300" />
            {todayHero.kicker}
          </span>
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-background-200/80">
            <i className="ri-calendar-2-line" />
            2026 / 09 / 08
          </span>
        </div>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-[54px] lg:leading-[1.12]">
          {todayHero.title.split("\\n").map((line, i) => (
            <span key={i} className="block">
              {i === 1 && (
                <span className="text-accent-300">{line.slice(0, 4)}</span>
              )}
              {i === 1 ? line.slice(4) : line}
            </span>
          ))}
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base">
          {todayHero.summary}
        </p>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {todayHero.tags.map((t) => (
            <span
              key={t}
              className="whitespace-nowrap rounded-md border border-background-100/30 px-3 py-1.5 text-xs text-background-100"
            >
              <i className="ri-price-tag-3-line mr-1.5 text-primary-300" />
              {t}
            </span>
          ))}
        </div>

        <div className="mt-10 grid max-w-3xl grid-cols-3 gap-4 border-t border-background-100/20 pt-6">
          {todayHero.meta.map((m) => (
            <div key={m.label}>
              <div className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {m.num}
              </div>
              <div className="mt-1 text-xs text-background-200/70">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}